<template>
    <div class="cart-global">
    <h2 class="h4 d-none d-md-block text-uppercase border border-secondary mb-3 p-2 ps-3 fw-bold">Produits commandés</h2>
        <table class="table table-bordered text-center align-middle mb-4">
            <thead class="align-middle">
            <tr class="table-secondary">
                <th scope="col">Réf.</th>
                <th scope="col">Image</th>
                <th scope="col">Description</th>
                <th scope="col">Conditionnement</th>
                <th scope="col" class="cart-promo">Promotion / bénéfice</th>
                <th scope="col">Quantité totale</th>
            </tr>
            </thead>
            <tbody class="text-uppercase fw-bold">
                <product-item v-for="item in products" :item="item" :key="item.id" ></product-item>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "Cart",
        data: function () {
            return {
                loading: true,
                products: []
            }
        },
        mounted() {
            this.loadCarProducts();
        },
        created() {

        },
        methods: {
            loadCarProducts: function() {
                axios.get('/panier-promo/json', {
                })
                    .then((response) => {
                        this.products = response.data.articles;
                        this.loading = false;
                    })
                    .catch(function (error) {

                    });
            }
        }
    }
</script>
